import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styled from "styled-components";
import {RiAccountCircleFill, RiCloseFill} from "react-icons/ri";
import {setAlert} from "../../Redux/actions/alertAction";
import {selectGroup} from "../../Redux/actions/contactAction";
import multiavatar from "@multiavatar/multiavatar/esm";

const ChatGroupHeader = ({selectGroup, selectedGroup, setAlert}) => {

    return (
        <Container>
            <div className='account-container'>
                {
                    selectedGroup.group_image ?
                        <div className='avatar'
                             dangerouslySetInnerHTML={{__html: multiavatar(selectedGroup.group_image)}}>
                        </div>
                        :
                        <RiAccountCircleFill className='avatar-icon'/>
                }
                <div className="account-detail-container">
                    <h4>{selectedGroup.display_name}</h4>
                    <p>{selectedGroup.group_name}</p>
                </div>
            </div>

            <div className='flex-container'>
                <RiCloseFill className='menu-icon' onClick={() => selectGroup(null)}/>
            </div>
        </Container>
    );
}

ChatGroupHeader.propTypes = {
    selectedGroup: PropTypes.object,
    selectGroup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    selectedGroup: state.contact.selectedGroup,
    setAlert: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {selectGroup, setAlert})(ChatGroupHeader);

const Container = styled.div`
  display: flex;
  padding: 40px 8px;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-bottom: #F0EFF5 1px solid;
  z-index: 1;

  .account-container {
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
  }

  .menu-icon {
    font-size: 20px;
    padding: 15px;
    border-radius: 0.5rem;
    cursor: pointer;
    color: #878A92;
  }

  .avatar {
    width: 2.3rem;
    padding-right: 15px;
  }

  .avatar-icon {
    font-size: 40px;
    padding-right: 15px;
  }

  .flex-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .sign-button {
    cursor: pointer;
    color: #fff;
    background-color: #7269ef;
    line-height: 1.5;
    padding: 0.65rem 1rem;
    border-radius: 0.25rem;
    border: none;
    transition: 0.25s;
    font-size: 0.9rem;

    :hover {
      background-color: #6159cb;
      border-color: #5b54bf;
    }
  }
`;